import { createContext } from "react";
import type { ThemeToken } from "./themeTokens.generated";
import type { ThemeDefinition, ThemeFieldVariant, ThemeId } from "./themeCatalog";
import type { ThemeAvailability } from "./themeRuntime";

export type AppThemeContextValue = {
  themeDrawer: { initialThemeId: ThemeId; selectedThemeId: ThemeId; tr: (key: string) => string } | null;
  openThemeDrawer: (tr: (key: string) => string) => void;
  closeThemeDrawer: () => void;
  setThemeDrawerPreview: (id: ThemeId | null) => void;
  /** Wirksames Theme (Vorschau, Benutzerwahl oder Vorgabe). */
  themeId: ThemeId;
  theme: ThemeDefinition;
  /** Design-Tokens des wirksamen Themes (Antd-Schlüssel, bis Stufe 8 von Antd berechnet und eingefroren). */
  token: ThemeToken;
  fieldVariant: ThemeFieldVariant;
  /** In dieser App wählbare Themes in Katalogreihenfolge. */
  availableThemes: ThemeDefinition[];
  availability: ThemeAvailability | null;
  /** Gespeicherte Benutzerwahl, auch wenn sie gerade nicht freigegeben ist. */
  userThemeId: ThemeId | null;
  /** Benutzerwahl speichern (lokal und über `onUserThemeChange`). */
  setThemeId: (id: ThemeId) => void;
  /** Vom Server geladene Benutzerwahl übernehmen, ohne sie erneut zu speichern. */
  adoptUserThemeId: (id: ThemeId | null) => void;
  setAvailability: (availability: ThemeAvailability | null) => void;
  /** Lädt die Vorgaben über den zuletzt registrierten Lader neu (nach Admin- oder Mandantenänderung). */
  reloadAvailability: () => Promise<void>;
  /** Interner Vertrag von `useThemeAvailabilitySync`. */
  registerAvailabilityLoader: (load: (() => Promise<unknown>) | null) => void;
  /**
   * Serverseitige Speicherung der Benutzerwahl aus einem Baustein innerhalb der Anmeldung
   * (statt `onUserThemeChange` am Provider); `null` meldet ab.
   */
  registerUserThemePersistence: (persist: ((id: ThemeId) => void) | null) => void;
  previewThemeId: ThemeId | null;
  /** Theme vorübergehend anwenden (Theme-Auswahl); `null` beendet die Vorschau. */
  setPreviewThemeId: (id: ThemeId | null) => void;
};

export const AppThemeContext = createContext<AppThemeContextValue | null>(null);
